<template>
  <v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-3"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">ATTENDANCE</div>
                        <div class="text-h6 font-weight-bold primary--text">Mark Students' Attendance - {{ currentTerm.term_session }}</div>
                        <div class="text-body-2 grey--text">Keep track of your students' attendance for the current Term</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="5">
                            <v-select v-model="selectedClass" :items="classes" item-text="class"
                                        item-value="class_id"
                                        label="Select Class"
                                        outlined dense
                                        prepend-inner-icon="mdi-google-classroom"
                                        @change="loadTermAttendance" />
                        </v-col>
                        <v-col cols="12" md="7">
                            <v-alert
                                type="info"
                                dense
                                border="left"
                                text
                                color="red"
                                >
                                <marquee>
                                    Only Terms with Start and End Dates will display here. Update your Terms &nbsp; &nbsp; | &nbsp; &nbsp; Only the last 5 Terms Attendance records are kept. We recommend you to export your student attendance regularly
                                </marquee>
                            </v-alert>
                        </v-col>
                    </v-row>

                    <!-- Horizontal Scroll Table -->
                    <v-card outlined class="rounded-lg">
                        <div class="table-wrapper">
                          <table class="term-table">
                            <thead>
                            <tr>
                                <th rowspan="2">Student</th>
                                <th rowspan="2">Days Present</th>
                                <th v-for="date in dateColumns" :key="date" colspan="1">
                                {{ formatDate(date) }}
                                </th>
                            </tr>
                            <tr>
                                <th v-for="date in dateColumns" :key="date + '-day'" :class="isWeekend(date) ? 'weekend-header' : ''">
                                {{ formatDay(date) }}
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                              <tr v-for="student in students" :key="student.id">
                                <td>{{ student.name }}</td>
                                <td>
                                  {{ getDaysPresent(student) }}
                                </td>
                                <td
                                v-for="date in dateColumns"
                                :key="date"
                                :class="isWeekend(date) ? 'weekend-cell' : ''"
                                >
                                <!-- Today: interactive -->
                                <div v-if="isToday(date)">
                                    <v-select
                                    :items="statuses"
                                    v-model="student.todayStatus"
                                    dense hide-details outlined
                                    class="status-cell"
                                    :menu-props="{ offsetY: true }"
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                            :color="getStatusColor(data.item)"
                                            dark
                                            small
                                            >
                                            <v-icon small left>{{ getStatusIcon(data.item) }}</v-icon>
                                            {{ data.item }}
                                            </v-chip>
                                    </template>
                                </v-select>
                                </div>

                                <!-- Past: read-only -->
                                <div v-else>
                                    <v-chip
                                    v-if="student.attendance[date]"
                                    small
                                    :color="getStatusColor(student.attendance[date])"
                                    dark
                                    >
                                    <v-icon small left>{{ getStatusIcon(student.attendance[date]) }}</v-icon>
                                    {{ student.attendance[date] }}
                                    </v-chip>

                                    <v-chip small color="grey" dark v-if="isWeekend(date)">
                                    <v-icon small left>mdi-calendar-weekend</v-icon>
                                    Weekend
                                    </v-chip>
                                </div>
                                </td>

                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </v-card>

                    <v-btn v-if="showSaveButton && isTodayInRange" color="primary" rounded elevation="2" class="font-weight-bold text-none mt-4" @click="saveTodaysAttendance">
                      <v-icon left>mdi-content-save-outline</v-icon>
                      Save Today's Attendance
                    </v-btn>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import HeaderVue from '../../components/Header.vue'
export default {
    components: {
        HeaderVue
    },
    data() {
        return {
            currentTerm: 1,
            selectedClass: '',
            selectedSession: '',
            terms: ['Term 1', 'Term 2', 'Term 3'],
            sessions: ['2024/2025', '2025/2026'],
            students: [],
            statuses: ['punctual', 'absent', 'late'],
            startDate: null,
            endDate: null,
            dateColumns: [],
            authToken:sessionStorage.getItem('authToken') ?? null,
            accessToken:sessionStorage.getItem('accessToken') ?? null,
            school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : {},
            classes:[],
            showSaveButton: false
        };
    },
    computed: {
        isTodayInRange() {
            const today = moment();
            const start = moment(this.startDate);
            const end = moment(this.endDate);

            return today.isSameOrAfter(start, 'day') && today.isSameOrBefore(end, 'day');
        }
    },
    mounted() {
       this.fetchClasses()
       this.fetchCurrentTerm()
    },
    methods: {
        loadTermAttendance() {
            if (!this.selectedClass) {
                return false;
            }
            axios.get(process.env.VUE_APP_BASEURL+'/attendances?school_id='+this.school.school_id+'&clasx_id='+this.selectedClass,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
            })
            .then((res) => {
                this.students = res.data.students.map(student => ({
                    id: student.id,
                    name: student.name,
                    attendance: student.attendance, // { '2025-07-01': 'punctual', ... }
                    todayStatus: student.attendance[moment().format('YYYY-MM-DD')] || 'punctual',
                }));
                this.showSaveButton = true
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
        },
        saveTodaysAttendance() {
            const today = moment().format('YYYY-MM-DD');

            // Gather attendance for today
            const payload = {
                school_id: this.school.school_id,
                clasx_id: this.selectedClass,
                date: today,
                records: this.students.map(student => ({
                    student_id: student.id,
                    status: student.todayStatus || 'punctual',
                })),
            };

            this.loading = true;
            axios.post(process.env.VUE_APP_BASEURL+'/attendances?school_id='+this.school.school_id, payload,
                {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
            })
            .then(res => {
                console.log(res.data.message);
                this.$toast.success('Attendance saved!');
                this.loadTermAttendance(); // Refresh attendance
            })
            .catch(err => {
                this.$toast.error('Failed to save attendance');
                console.error(err);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchClasses () {
            axios.get(process.env.VUE_APP_BASEURL+'/classes?school_id='+this.school.school_id+'&type=dropdown',
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken,
                    'X-Access-Token': this.accessToken,
                }
            })
            .then((response) => {
                this.classes =  response.data.data
                    if (this.classes.length == 0) {
                    this.$toast.info('You will need to set classes first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Classes'})
                }
                this.reRenderComponent = false;
                this.$nextTick(() => {
                // Add the component back in
                this.reRenderComponent = true;
                });
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Internet Network Not Available!', {
                    timeout: 5000
                });
            })
        },
        fetchCurrentTerm () {
            axios.get(process.env.VUE_APP_BASEURL+'/parameters?school_id='+this.school.school_id+'&type=current-term',
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
            })
            .then((response) => {
                this.currentTerm =  response.data.data
                this.startDate = moment(response.data.data.start_date);
                this.endDate = moment.min(moment(), moment(response.data.data.end_date));
                // Generate date columns from today (or end date) to start
                let date = this.endDate.clone();
                while (date >= this.startDate) {
                    this.dateColumns.push(date.format('YYYY-MM-DD'));
                    date = date.subtract(1, 'day');
                }
                if (!this.currentTerm) {
                    this.$toast.info('You will need to set a session/term first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Terms'})
                }
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
            });
        },
        getStudentPercentage(student) {
        // Only consider days where attendance is recorded
        const recordedDays = Object.values(student.attendance).filter(status => ['punctual', 'absent', 'late'].includes(status));
        const total = recordedDays.length;

        if (total === 0) return 0;

        const punctualDays = recordedDays.filter(status => status === 'punctual').length;
        return Math.round((punctualDays / total) * 100);
        },

        getDaysPresent(student) {
        // Only consider days with valid attendance
        const recordedDays = Object.values(student.attendance).filter(status =>
            ['punctual', 'absent', 'late'].includes(status)
        );

        if (recordedDays.length === 0) return 0;

        // Count both punctual and late as present
        return recordedDays.filter(status => ['punctual', 'late'].includes(status)).length;
        },


        isToday(date) {
            return date === moment().format('YYYY-MM-DD');
        },
        formatDate(date) {
            return moment(date).format('DD MMM');
        },
        getStatusColor(status) {
            return { punctual: 'green', absent: 'red', late: 'orange' }[status];
        },
        getStatusIcon(status) {
            return { punctual: 'mdi-check-circle', absent: 'mdi-close-circle', late: 'mdi-alert-circle' }[status];
        },
        formatDay(date) {
            return moment(date).format('ddd').toUpperCase(); // e.g., MON, TUE
        },
        isWeekend(date) {
            const day = moment(date).day(); // 0 = Sunday, 6 = Saturday
            return day === 0 || day === 6;
        },

  }
}
</script>

<style scoped>
.table-wrapper {
  overflow-x: auto;
}
.term-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
}
.term-table th, .term-table td {
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #ECEFF7;
  min-width: 100px;
}
.term-table th {
  background: #F4F6FB;
  color: #1E3C72;
  font-weight: 700;
  letter-spacing: 0.5px;
  font-size: 0.72rem;
  text-transform: uppercase;
  border-bottom: 2px solid #E3E8F4;
}
.term-table tbody tr:hover {
  background: #F4F6FB;
}
.status-cell {
  max-width: 150px;
}
.weekend-header {
  background-color: #FBEAEA !important;
  color: #C62828 !important;
  font-weight: bold;
}

.weekend-cell {
  background-color: #FFF5F5;
}

</style>
